module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/exception_frame-665bf2a433b06f5727ec9ba5abcf3e29.png";